import { getItem } from '../storage';
import i18n from 'components/i18n';

/**
 * @deprecated:
 *   Not actually deprecated, but you probably want useFetchWithAuth useMutationWithAuth or useRequestWithAuth instead.
 *   If you are writing a hook that wraps this, then carry on. :)
 */
export const getHeaders = (): { [key: string]: string } => {
    const headers: { [key: string]: string } = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'lang': i18n.language,
    };

    const userData = getItem('user');

    let token;

    if (userData) {
        token = userData.token;
    }

    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    return headers;
};
